import { Component, AfterViewInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { DtAddressService } from '../../../service/dt-address/dt-address.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { AgGridHelper } from '../../../util/AgGridHelper';

@Component({
  selector: 'wa0020',
  templateUrl: 'wa0020.component.html',
  styleUrls: ['wa0020.component.scss']
})
export class Wa0020Component implements AfterViewInit, OnChanges {
  private gridApi: any;
  public componentTitle = 'WA0020:届先選択';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  public errorInfo: string = '';

  private gridHelper: AgGridHelper;

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<object>();
  private isDelayHide = true;

  @ViewChild('gridView')
  gridView: ElementRef;

  /** pagination */
  private totalCount = 0;
  private selectedCount = 0;
  private currentPage = 0;
  private maxPage = 0;
  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;
  private isEnableClearFilterButton = false;

  constructor(private router: Router, private dtAddressService: DtAddressService, private commonService: CommonService) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.gridSelectionCheckboxStyle = 'radio';
    this.gridOptions = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa0020_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.paginatorRowChange();
      },
      onRowDataChanged: () => {
        this.gridHelper.onRowDataChanged();

        if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.gridHelper.isShowGridNoDataOverlay = false;
        else this.gridHelper.isShowGridNoDataOverlay = true;
      },
      onSelectionChanged: () => {
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.gridHelper.fixedAgMenu();
      },
      onPaginationChanged: () => {
        this.totalCount = this.gridOptions.api.paginationGetRowCount();
        this.maxPage = this.gridOptions.api.paginationGetTotalPages();
        this.currentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      onSortChanged: () => {
        this.gridHelper.renderGridCheckboxImage();
        this.errorInfo = '';
      },
      onFilterChanged: () => {
        this.selectedCount = 0;
        this.gridHelper.onGridFilterChanged();
        this.isEnableClearFilterButton = this.gridOptions.api.isAnyFilterPresent();
        this.errorInfo = '';
      },
      onCellClicked: param => {
        var cols = param.colDef.field;
        var index = param.rowIndex;
        if (cols == 'checkbox') {
          var node = this.gridOptions.api.getRowNode(index);
          if (node.isSelected()) {
            node.setSelected(false);
          } else {
            node.setSelected(true);
          }
        }
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        width: 40,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        pinned: true,
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        suppressMenu: true
      },
      {
        headerName: '届先コード',
        field: 'dtaddressCd',
        sort: 'asc',
        width: this.getColumnWidth('dtaddressCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先名',
        field: 'dtnameTx',
        width: this.getColumnWidth('dtnameTx', 150),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先住所1',
        field: 'dtaddress1Tx',
        width: this.getColumnWidth('dtaddress1Tx', 150),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先住所2',
        field: 'dtaddress2Tx',
        width: this.getColumnWidth('dtaddress2Tx', 150),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先住所3',
        field: 'dtaddress3Tx',
        width: this.getColumnWidth('dtaddress3Tx', 150),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先住所4',
        field: 'dtdepartmentTx',
        width: this.getColumnWidth('dtdepartmentTx', 150),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先Tel',
        field: 'dttelTx',
        width: this.getColumnWidth('dttelTx', 130),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先Fax',
        field: 'dtfaxTx',
        width: this.getColumnWidth('dtfaxTx', 130),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 160),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 120),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 160),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 120),
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    //this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    if (window.innerHeight <= 640) {
      this.gridHeight = 400;
    }
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa0020_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa0020_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa0020_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    /*
    setTimeout(() => {
      this.onSubmit();
    }, 500);
    */
    this.gridHelper.el = this.gridView;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    //this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  onSubmit() {
    this.onFilterClear();
    this.working = true;
    this.dtAddressService
      .get()
      .then(outputJson => {
        console.log(JSON.stringify(outputJson));
        this.rowData = outputJson.dtaddresses;
        this.working = false;
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.working = false;
      });
  }

  onSelect() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    } else {
      // set the selected data to the session storage for conveying to the parent window
      const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
      sessionStorage.setItem('rowDtaddress', JSON.stringify(this.rowData[selectedIndex]));
      sessionStorage.setItem('dtaddressSelected', '1');
      // back to the parent window
      const parentWindow = sessionStorage.getItem('parentWindow');
      this.router.navigate([parentWindow]);
    }
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.selectedCount = 0;
      this.isDelayHide = false;
      setTimeout(() => {
        this.onSubmit();
      }, 500);
    } else {
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  cancel() {
    //this.router.navigate(['wa1010']);
    this.closeButtonClick.emit(null);
  }

  onItemSelectButtonClick() {
    this.errorInfo = '';
    if (this.selectedCount == 0) return;
    var node = this.gridOptions.api.getSelectedNodes()[0];
    this.closeButtonClick.emit(node.data);
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa0Common/wa0020/wa0020.component.ts